import { render, staticRenderFns } from "./WeddingParty.vue?vue&type=template&id=01382214&scoped=true&"
import script from "./WeddingParty.vue?vue&type=script&lang=js&"
export * from "./WeddingParty.vue?vue&type=script&lang=js&"
import style0 from "./WeddingParty.vue?vue&type=style&index=0&id=01382214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01382214",
  null
  
)

export default component.exports